import config from '../internetConfig';
import utils from '../../utils';
import axios from 'axios';

let topTermsMap = {};

/**
 * Load up the map of top terms
 */
const load = new Promise((resolve) => {
	if (!config.topTerms || !utils.isEmpty(topTermsMap)) {
		return resolve(true);
	}

	// if cios URL is set, load the cios data
	axios
		.get(config.topTerms)
		.then((response) => {
			let items = String(response.data)
				.replace(/["\n]+/g, '')
				.split(/,\s*/);
			if (10 > items.length) {
				return resolve();
			}
			items.forEach((item) => {
				item = item.split(/\s*:\s*/);
				if (2 !== item.length) {
					return false;
				}
				let term = utils.cleanString(item[0]).toLowerCase();
				let score = utils.toNumber(item[1]);
				if (term && score) {
					topTermsMap[term] = score;
				}
			});
			resolve();
			return;
		})
		.catch((error) => {
			config.debug && console.error('Search: TopTerms Error:', error);
			resolve();
			return;
		});
	return;
});

const getTopQueryTerms = (query) => {
	let topTokenList = [];
	let spaceStatus = {};
	let conflicts = {};
	let length = 1;
	let tokens= utils.getWords(query);
	while (length < tokens.length) {
		let start = 0;
		while (start <= tokens.length - length) {
			let testToken = tokens.slice(start,start + length).join(' ');
			if (topTermsMap[testToken.toLowerCase()]) {
				let testTokenScore = Math.log(topTermsMap[testToken.toLowerCase()]) + length - 1;
				processTerm(testToken, start, length, testTokenScore, spaceStatus, conflicts);
			}
			start++;
		}
		length++
	}
	let longTermCheck = {};
	for (var position in spaceStatus) {
		let term = spaceStatus[position].term;
		if (!conflicts[term] && longTermCheck !== term) {
			topTokenList.push({'term':term, 'score':spaceStatus[position].score});
			if (1 < term.length) {
				longTermCheck = term;
			}
		}
	}
	let usedConflicts = getBestConflictedTerms(conflicts, 0, [], {});
	if (usedConflicts && usedConflicts.termData) {
		for (var i in usedConflicts.termData) {
			let data = usedConflicts.termData[i];
			topTokenList.push({'term':data.term, 'score':data.score});
		}
	}
	topTokenList.sort((a,b) => b.score - a.score);
	config.debug && console.debug('Search: Top Terms matched: ', topTokenList);
	return topTokenList;
}

// separated function to save necessary information for each token match and check for positional conflicts.
var processTerm = function(term, start, length, score, spaceStatus, conflicts) {
	let position = start;
	let details = {'term':term, 'start':start, 'length':length, 'score': score};
	while (position < start + length) {
		if (spaceStatus[position]) {
			conflicts[term] = details;
			let conflictTerm = spaceStatus[position].term;
			conflicts[conflictTerm] = spaceStatus[position];
		} else {
			spaceStatus[position] = details ;
		}
		position++;
	}
}
// Separated function to resolve conflicted token matches and add to list.
var getBestConflictedTerms = function(conflicts, totalScore, usedConflicts, occupiedPositions) {
	var conflict = {};
	for (var term in conflicts) {
		conflict = conflicts[term];
		break;
	}
	// No further conflicts. Return existing values.
	if (!conflict || JSON.stringify(conflict) === '{}') {
		return {'totalScore': totalScore, 'termData': usedConflicts};
	}
	// recursive call without first conflict.
	let conflictCopyOff = JSON.parse(JSON.stringify(conflicts));
	delete conflictCopyOff[conflict.term];
	let recurseOffResult = getBestConflictedTerms(conflictCopyOff, totalScore, usedConflicts, occupiedPositions);

	// Recursive call with conflict and set occupied positions.
	let occupiedPositionsCopy = JSON.parse(JSON.stringify(occupiedPositions));
	// indicate which positions will be blocked and check if this term is already blocked.
	for (var i = conflict.start; i<conflict.start + conflict.length; i++) {
		if (occupiedPositionsCopy[i]) {
			//This term is blocked, return the result from not using this term.
			return recurseOffResult;
		}
		occupiedPositionsCopy[i] = true;
	}
	let conflictCopyOn = JSON.parse(JSON.stringify(conflicts));
	let usedConflictsCopy = JSON.parse(JSON.stringify(usedConflicts));
	delete conflictCopyOn[conflict.term];
	usedConflictsCopy.push(conflict);
	let updatedTotalScore = totalScore + conflict.score;
	let recurseOnResult = getBestConflictedTerms(conflictCopyOn, updatedTotalScore, usedConflictsCopy, occupiedPositionsCopy);
		if (!recurseOnResult || !recurseOnResult.totalScore) {
		return recurseOffResult;
	}
	if (!recurseOffResult || !recurseOffResult.totalScore) {
		return recurseOnResult;
	}
	if (recurseOnResult.totalScore > recurseOffResult.totalScore) {
		return recurseOnResult;
	} else {
		return recurseOffResult;
	}
}


/**
 * Alters the SOLR query if top term matches are found
 *
 * @param {*} query
 * @param {*} searchParts
 * @returns
 */
const queryFilter = (query, searchParts) => {
	// return if top terms are disabled or not available
	if (utils.isEmpty(topTermsMap)) {
		return query;
	}
	// return if we don't have a query for whatever reason
	let searchTerms = searchParts.query;
	if (!Array.isArray(searchTerms) || !searchTerms.length) {
		return query;
	}

	let topQueryTerms = getTopQueryTerms(searchTerms);

	if (!topQueryTerms || !topQueryTerms.length) {
		return query;
	}

	//Ensure bf parameter is initialized.
	query.bf = utils.toArray(query.bq ? query.bq : []);
	let queryIndex = 1;
	let bfString = 'product(1.5,' + topQueryTerms.length + ',pow(product('
	topQueryTerms.forEach((topQueryTerm) => {
		let key = "topTermsQ" + queryIndex;
		queryIndex++;
		query[key] = "query({!edismax boost='' bf='' v='\"" +  utils.cleanChars(topQueryTerm.term).replace("'","\\'") + "\"~2'})";
		bfString += 'max(1,$' + key + '),'
	});
	// Remove trailing comma and complete boost string.
	bfString = bfString.substring(0, bfString.length - 1);
	bfString = bfString + '),div(1,' + topQueryTerms.length + ')))'
	query.bf = bfString;

	return query;
};

export default { load, queryFilter, getTopQueryTerms };
